/**
 * Belge kategorilerini günceller
 * 
 * @param {Object} options - Yapılandırma seçenekleri
 * @param {Object} options.axios - Axios örneği
 * @param {Object} options.settings - URL ayarları
 * @param {String} options.assetId - Geçerli varlık ID'si
 * @param {String} options.documentId - Güncellenecek belgenin ID'si
 * @param {Array} options.categoryIds - Atanacak kategori ID'leri dizisi
 * @returns {Promise<Object>} - API yanıtı
 */
export const updateDocumentCategories = async (options) => {
  const { axios, settings, assetId, documentId, categoryIds } = options;
  
  if (!documentId) {
    throw new Error('Belge ID\'si gereklidir');
  }
  
  try {
    // Convert IDs to ensure consistent type handling
    const normalizedDocumentId = parseInt(documentId);
    const normalizedAssetId = parseInt(assetId);
    // Ensure all categoryIds are numbers
    const normalizedCategoryIds = Array.isArray(categoryIds) 
      ? categoryIds.map(id => parseInt(id))
      : [];
      
    const response = await axios.put(settings.updateDocumentCategories, {
      documentId: normalizedDocumentId,
      assetId: normalizedAssetId,
      categoryIds: normalizedCategoryIds,
    });
    
    return response.data;
  } catch (error) {
    console.error('Belge kategorileri güncellenirken hata oluştu:', error);
    throw error;
  }
}